import { PosModel } from '@/types'

export const demoCustomers: PosModel.Customer[] = [
  { _id: 'c-001', name: 'Nusrat Jahan', phone: '01711000101', email: 'nusrat@example.com', loyalty_points: 340, total_orders: 27 },
  { _id: 'c-002', name: 'Tanvir Ahmed', phone: '01811000202', loyalty_points: 85, total_orders: 6 },
  { _id: 'c-003', name: 'Farhana Akter', phone: '01911000303', email: 'farhana@example.com', loyalty_points: 1210, total_orders: 64 },
  { _id: 'c-004', name: 'Rahim Uddin', phone: '01611000404', loyalty_points: 0, total_orders: 1 },
  { _id: 'c-005', name: 'Sadia Islam', phone: '01511000505', loyalty_points: 560, total_orders: 31 },
  { _id: 'c-006', name: 'Arif Hossain', phone: '01311000606', email: 'arif@example.com', loyalty_points: 145, total_orders: 12 },
]
